import { render, staticRenderFns } from "./activity-center.vue?vue&type=template&id=39a84572&scoped=true"
import script from "./activity-center.vue?vue&type=script&lang=js"
export * from "./activity-center.vue?vue&type=script&lang=js"
import style0 from "./activity-center.vue?vue&type=style&index=0&id=39a84572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a84572",
  null
  
)

export default component.exports